import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { logError } from '@/lib/logger';

const readSessionId = () => new URLSearchParams(window.location.hash.replace('#', '?')).get('session_id');

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const sessionId = readSessionId();

        if (!sessionId) {
          navigate('/login');
          return;
        }

        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const { data } = await axios.post('/api/auth/google-session', { session_id: sessionId }, { withCredentials: true });

        // Clean URL and navigate to admin
        window.history.replaceState({}, '', '/admin');
        navigate('/admin', { state: { user: data.user } });
      } catch (err) {
        logError('Auth callback failed:', err);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-saffron/20 border-t-saffron rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-earth/60 font-sans">Signing you in...</p>
      </div>
    </div>
  );
}
